import { useEffect, useState } from 'react'
import { Package } from 'lucide-react'
import { apiClient } from '@/services/apiClient'
import { productImageEndpoint } from '@/services/products'

export function ProductImageThumb({ productId, hasImage }: { productId: string; hasImage: boolean }) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!hasImage) return
    let cancelled = false
    let created: string | null = null
    async function load() {
      try {
        const res = await apiClient.fetch(productImageEndpoint(productId))
        if (!res.ok) return
        const blob = await res.blob()
        if (cancelled) return
        created = URL.createObjectURL(blob)
        setObjectUrl(created)
      } catch {
        /* ignore — thumbnail is non-critical */
      }
    }
    load()
    return () => {
      cancelled = true
      if (created) URL.revokeObjectURL(created)
    }
  }, [productId, hasImage])

  if (!hasImage || !objectUrl) {
    return (
      <div className="flex h-16 w-16 items-center justify-center rounded-sm bg-muted">
        <Package className="h-5 w-5 text-muted-foreground" />
      </div>
    )
  }
  return <img src={objectUrl} alt="" className="h-16 w-16 rounded-sm object-cover border border-border" />
}
